import PagingItem from "./PagingItem";

export default function Paging({current, last, baseurl}){
  const pageSize = 4;
  const page = Math.floor((current>1?current-1:current)/pageSize);
  const start = (page*pageSize)+1;
  const end = start + (pageSize-1) > last? last:start+(pageSize-1);
  console.log(current, page, start, end)

  const previous = page > 0;
  const next = end < last;

  const links=[];
  links.push({text:`<`, isactive: previous});
  for(let i = start; i<= end; i++){
    links.push({text:`${i}`, isactive:true})
  }
  links.push({text:`>`, isactive:next})

  return (
    <div className="flex flex-row flex-wrap my-6">
      {links.map((l, i)=> {
        let pageIndex= 1;
        if(l.text === '<' && l.isactive) pageIndex = start-1;
        else if(l.text === '>' && l.isactive) pageIndex = end+1;
        else pageIndex = +(l.text);
        const url = `${baseurl}?page=${pageIndex}`;
        const iscurrent = pageIndex ===(current); 

        return <PagingItem key={i} href={url} text={l.text} isactive={l.isactive} iscurrent={iscurrent}/>
      }
    )}
    </div>
  );
}